import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { EditPanelCell, EditPanelRow, PanelBody, PanelHeading } from '../../elements';
import { NullableFormattedDate } from '../../utils/NullableFormattedDate';
import { ISurvey } from '../Interfaces/ISurvey';

export function SurveyDetailsSignature(props: { surveyDetails: ISurvey }) {
    const translate = useTranslate();

    return (
        <div id="Signature" className="panel">
            <PanelHeading text={translate('survey.signature')} icon="fa fa-gavel" />
            <PanelBody whiteBackground={true}>
                <EditPanelRow>
                    <EditPanelCell rowCount={5}>
                        <strong>{translate('survey.preparedBy')}</strong> <br />
                        {props.surveyDetails.preparedAuthor}&nbsp;
                        <NullableFormattedDate value={props.surveyDetails.preparedDate} />
                    </EditPanelCell>
                    <EditPanelCell rowCount={5}>
                        <strong>{translate('survey.verifiedBy')}</strong>
                        <br />
                        {props.surveyDetails.verifiedAuthor}&nbsp;
                        <NullableFormattedDate value={props.surveyDetails.verifiedDate} />
                    </EditPanelCell>
                </EditPanelRow>
            </PanelBody>
        </div>
    );
}
